// Vendor Components
import React from 'react';

import Icon from '../core/icon';

// Styles
import './no-match.scss';

function NoMatch() {
    return (
        <section className="no-match">
            <h2>The requested page could not be found</h2>
            <div className="no-match--background">
                <Icon className="no-match--background-cloud" fontType="fa" iconName="cloud" />
                <Icon className="no-match--background-cloud" fontType="fa" iconName="cloud" />
            </div>
        </section>
    );
}

export default NoMatch;
